var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1767_30373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 17H8C7.07069 17 6.60603 17 6.21964 17.0769C4.63288 17.3925 3.39249 18.6329 3.07686 20.2196C3 20.606 3 21.0707 3 22H21C21 21.0707 21 20.606 20.9231 20.2196C20.6075 18.6329 19.3671 17.3925 17.7804 17.0769C17.394 17 16.9293 17 16 17Z",
    fill: "#E3ECF3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 6,
    fill: "#9FA9BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4472 18.2764C15.3237 18.0294 15.0234 17.9293 14.7764 18.0528C14.5294 18.1763 14.4293 18.4766 14.5528 18.7236L15.4472 18.2764ZM21.416 16.7774L21.6934 16.3613L20.8613 15.8066L20.584 16.2226L21.416 16.7774ZM17.9558 21.0662L17.5398 20.7889L17.9558 21.0662ZM14.5528 18.7236L15.7822 21.1823L16.6766 20.7351L15.4472 18.2764L14.5528 18.7236ZM18.3719 21.3436L21.416 16.7774L20.584 16.2226L17.5398 20.7889L18.3719 21.3436ZM15.7822 21.1823C16.2972 22.2125 17.733 22.3019 18.3719 21.3436L17.5398 20.7889C17.3269 21.1083 16.8483 21.0785 16.6766 20.7351L15.7822 21.1823Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1767_30373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadyes);
export default __webpack_public_path__ + "static/media/leadyes.c305408e4b2fb5164a4a6481ec542858.svg";
export { ForwardRef as ReactComponent };